import React, { useState, useEffect } from "react";
import useScrollToTop from "../../hooks/useScollToTop";
import axios from "axios";
import { toast } from "react-toastify";

const FaqPage = () => {
  useScrollToTop();

  const [faqs, setFaqs] = useState([]);
  const [groupedFaqs, setGroupedFaqs] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const apiBase = "https://api.monappliclub.com/api/faqs";

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(`${apiBase}/allFaqs`);
      const allFaqs = response.data || [];
      setFaqs(allFaqs);
      groupByCategorie(allFaqs);
    } catch (error) {
      toast.error("Erreur lors du chargement des FAQ.");
    }
  };

  const searchFaqs = async (term) => {
    try {
      const response = await axios.get(
        `${apiBase}/search?q=${encodeURIComponent(term)}`
      );
      const results = response.data || [];
      groupByCategorie(results);
    } catch (error) {
      toast.error("Erreur lors de la recherche FAQ.");
    }
  };

  const groupByCategorie = (list) => {
    const grouped = list.reduce((acc, faq) => {
      const cat = faq.categorie || "Autres";
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(faq);
      return acc;
    }, {});
    setGroupedFaqs(grouped);
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim().length > 1) {
      searchFaqs(term);
    } else {
      groupByCategorie(faqs);
    }
  };

  return (
    <div className="flex flex-col w-full max-w-[1280px] mx-auto p-6 px-10 mt-[120px] bg-backgroundMain dark:bg-backgroundMainDark dark:text-white">
      <h1 className="text-xl tracking-widest text-gray-800 text-center dark:text-white">
        FAQ - Questions Fréquemment Posées
      </h1>
      <h2 className="text-4xl font-bold uppercase text-center my-6 mb-10">
        Avez-vous des questions ? Nous avons des réponses.
      </h2>

      {/* Champ de recherche */}
      <div className="w-full md:w-1/2 mx-auto mb-8">
        <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Rechercher une question ou un mot-clé..."
          className="w-full border border-gray-400 px-4 py-2 rounded-md shadow-sm text-gray-700"
        />
      </div>

      {/* Liste des FAQ groupées par catégorie */}
      <div className="space-y-8">
        {Object.keys(groupedFaqs).length === 0 ? (
          <p className="text-center text-gray-500">Aucune question trouvée.</p>
        ) : (
          Object.entries(groupedFaqs).map(([categorie, questions]) => (
            <div key={categorie}>
              <h3 className="text-2xl font-semibold mb-4 text-primary uppercase border-b border-gray-300 pb-1">
                {categorie}
              </h3>
              <div className="space-y-4">
                {questions.map((faq) => (
                  <details key={faq.id} className="group">
                    <summary className="text-lg font-medium cursor-pointer">
                      {faq.titre}
                    </summary>
                    <div
                      className="mt-2 p-4 bg-base-300 rounded-lg prose prose-sm max-w-full"
                      dangerouslySetInnerHTML={{ __html: faq.contenu }}
                    />
                  </details>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FaqPage;
